import { render, staticRenderFns } from "./LECO_SystemError404.vue?vue&type=template&id=2a0678c2"
import script from "./LECO_SystemError404.vue?vue&type=script&lang=js"
export * from "./LECO_SystemError404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports